import React from "react";
import { Card, Typography, Flex, Input, Select } from "antd";
import { styled } from "@mui/system";
const DataSheet = styled('div')`
    .ant-card-small >.ant-card-body {
      padding: 8px 6px;}
`;
export default function InputBox({ inputItem, inputType }) {
  const { Text } = Typography;
  const { Option } = Select;
  const { TextArea } = Input;
const configSelectMap = {
    constants: {
      idField: "id",
      label: (o) => o.title,
    },
    products: {
      idField: "netsuite_id",
      label: (o) => `${o.code} - ${o.name}`,
    },
    locations: {
      idField: "id",
      label: (o) => `${o.code}`,
    },
    sub_categories: {
      idField: "title",
      label: (o) => `${o.title}`,
    },
    helper: {
      idField: "id",
      label: (o) => `${o.first_name} ${o.last_name}`,
    },
  };
  return (
    <DataSheet>
      <>
        <Card
          size="small"
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            marginBottom: 4,
          }}
        >
          <Flex align="center" gap={8}>
            {inputItem.icon}
            <span style={{ fontWeight: 600, fontSize: '14px', color: "#595959" }}>
              {inputItem.label}
            </span>
          </Flex>
          {
            inputType == 'input' && (
              <Input
                placeholder={inputItem?.label}
                value={inputItem.value}
                readOnly={inputItem.readOnly}
                type={inputItem?.type == 'number' && 'number'}
                onChange={(e) => inputItem?.onChange?.(e.target.value)}
                style={{
                  background: inputItem?.readOnly ? "#fafafa" : "#ffffff",
                  borderRadius: 8,
                  cursor: "default",
                  fontWeight: 500,
                  color: "#262626",
                  maxWidth: "100%",
                }}
              />
            )
          }
          {
            inputType === 'select' && (
              <Select
                style={{ width: "100%" }}
                showSearch
                allowClear
                disabled={inputItem?.readOnly}
                value={inputItem?.value}
                placeholder={inputItem?.label}
                mode={inputItem?.type === 'select-multiple' ? 'multiple' : undefined}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) => inputItem?.onChange?.(value)}
              >
                {inputItem?.options?.map((option) => {
                  const config = configSelectMap[inputItem?.data] || configSelectMap.constants;                  
                  const id = option?.[config.idField];
                  const label = config.label(option);
                  return (
                    <Option key={id} value={id}>
                      {label}
                    </Option>
                  )
                }
                )}
              </Select>
            )
          }
          {inputType === 'notes' && (
                  <TextArea
                   value={inputItem?.value}
                   placeholder={inputItem?.label}
                   onChange={(e) => inputItem?.onChange?.(e.target.value)}
                   autoSize={{ minRows: 3, maxRows: 6 }} 
                   readOnly={inputItem?.readOnly}
                  />

                )}
        </Card>

      </>
    </DataSheet>
  );
}
